import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { LinkPage } from '@/widgets/link'

const searchSchema = z.object({
  workflowName: z.string().optional(),
})

export const Route = createFileRoute('/_app/workflows/links')({
  component: RouteComponent,
  validateSearch: (search) => searchSchema.parse(search),
})

export const WorkflowLinksRoute = Route

function RouteComponent() {
  return <LinkPage />
}
